// extracted by mini-css-extract-plugin
export default {"container":"Error_container__sSXhG","img":"Error_img__yt9XM"};